export const hideMainScroll = (toggler) => {
    if (toggler && !document.body.classList.contains('hideMainScroll') && document.documentElement.scrollHeight !== document.documentElement.offsetHeight) {
        document.body.classList.add('hideMainScroll')
    } else {
        document.body.classList.remove('hideMainScroll')
    }
}
